import React, { useEffect, useState } from "react";

const CustomCursor: React.FC = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [hoveringClickable, setHoveringClickable] = useState(false);
  const themeColors = {
    primary: "#B3955F", // Golden theme color
    secondary: "#333333", // Dark theme color
  };

  useEffect(() => {
    const moveCursor = (e: MouseEvent) => {
      setPosition({ x: e.clientX, y: e.clientY });

      // Detect if hovering over a clickable element
      const target = e.target as HTMLElement;
      if (target && (target.tagName === "BUTTON" || target.onclick)) {
        setHoveringClickable(true);
      } else {
        setHoveringClickable(false);
      }
    };

    window.addEventListener("mousemove", moveCursor);

    return () => {
      window.removeEventListener("mousemove", moveCursor);
    };
  }, []);

  return (
    <div
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`,
        transform: "translate(-50%, -50%)",
        width: hoveringClickable ? "40px" : "0px",
        height: hoveringClickable ? "40px" : "0px",
        backgroundColor: themeColors.primary,
        borderColor: themeColors.secondary,
        opacity: hoveringClickable ? 1 : 0,
      }}
      className={`custom-cursor fixed pointer-events-none z-50 rounded-full transition-transform duration-200 border-4`}
    ></div>
  );
};

export default CustomCursor;
